import React, { useState, useEffect } from 'react';
import '../App.css';
import './HeroSection.css';
import { GooglePlayButton } from "./GooglePlayButton";
import { AppStoreButton } from './AppStoreButton';
import { useTranslation } from "react-i18next";


function HeroSection() {

  const { t } = useTranslation();

  var [direction, setDirection] = useState('row');

  const changeDirection = () => {
    if (window.innerWidth <= 960) {
      setDirection('column');
    } else {
      setDirection('row');
    }
  };

  useEffect(() => {
    changeDirection();
  }, []);

  window.addEventListener('resize', changeDirection);

  return (
    <div className='hero-container'>
      <h1>{t('title.welcomeText')}</h1>
      <p>{t('text.whatAreYouWait')}</p>
      <div className='hero-btns'>
        <div
          className="store-buttons-container"
          style={{
            gap: 30,
            flexDirection: direction,
          }}
        >

          <GooglePlayButton url="https://play.google.com/store/apps/details?id=cz.midnighttree.questown"></GooglePlayButton>
          <AppStoreButton url="https://apps.apple.com/cz/app/questown/id6742157352"></AppStoreButton>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
